import React from "react";
import {
  AccordionItem,
  AccordionPanel,
  Drawer,
  DrawerOverlay,
  DrawerHeader,
  DrawerBody,
  DrawerContent,
  DrawerCloseButton,
  Text,
  Accordion,
  AccordionIcon,
  AccordionButton,
  Box,
} from "@chakra-ui/react";

import cv from "./Chinta-Sivanaryana-Resume.pdf"

import { Link } from "react-scroll"
export default function MobileMenu({ isOpen, onOpen, onClose }) {
  return (
    <>
      <Drawer placement={"left"} onClose={onClose} isOpen={isOpen} >
        <DrawerOverlay />
        <DrawerContent backgroundColor={"#425562"}>
          <DrawerCloseButton onClick={onClose} />
          <DrawerHeader borderBottomWidth="1px">Section</DrawerHeader>
          <DrawerBody margin={'auto'}   >
            <p  style={{ marginTop: "25px", fontSize: "30px", fontWeight: "bold", color: 'white' }}><Link to={"home"} smooth duration={1000} onClick={onClose}>Home</Link></p>
            <p  style={{ marginTop: "25px", fontSize: "30px", fontWeight: "bold", color: 'white' }}><Link to={"home"} smooth duration={1000} onClick={onClose}>About</Link></p>
            <p  style={{ marginTop: "25px", fontSize: "30px", fontWeight: "bold", color: 'white' }}> <Link to={"skills"} smooth duration={1000} onClick={onClose}>Skills</Link></p>
            <p  style={{ marginTop: "25px", fontSize: "30px", fontWeight: "bold", color: 'white' }}><Link to={"projects"} smooth duration={1000} onClick={onClose}>Projects</Link></p>
            <p  style={{ marginTop: "25px", fontSize: "30px", fontWeight: "bold", color: 'white' }}><Link to={"github"} smooth duration={1000} onClick={onClose}>Github</Link></p>
            <p  style={{ marginTop: "25px", fontSize: "30px", fontWeight: "bold", color: 'white' }}><Link to={"contacts"} smooth duration={1000} onClick={onClose}>Contact</Link></p>
            <a  href={cv} smooth="true" onClick={() => window.open("https://drive.google.com/file/d/1y6IF4HG_ykfG52FxvKLQfMO4h5qulomj/view?usp=share_link")}
              download={'Chinta-Sivanarayana-Resume.pdf'} textDecoration='null' target="_blank" rel="noreferrer"
            >
             <button style={{marginTop:"30px",color:"white"}} onClick={onClose}>Resume</button>
            </a>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
